const APP_VERSION = 'v 0.0.1';
// const isProductionServer = process.env.node_env === 'production';

// const API_URL = 'http://pdd846.03.testing.place/api';
// const APP_URL = 'http://pdd846.03.testing.place';

const API_URL2 = document.querySelector("meta[name='API_URL']").getAttribute('content');
const APP_URL2 = document.querySelector("meta[name='APP_URL']").getAttribute('content');

// TODO: Узнать прод сервер и сделать нормально
// if (isProductionServer) {
//   API_URL = 'http://pddback111.03.testing.place/api';
//   APP_URL = 'http://pddback111.03.testing.place';
// }

const settings = {
  APP_VERSION,
  API_URL: `${API_URL2}`,
  APP_URL: `${APP_URL2}`,
  // ключи для хранения в localStorage
  ID_TOKEN: 'token',
  REFRESH_TOKEN: 'refresh_token',
  //  прочие, может потом пригодиться
  // uploadPath: `${API_URL}upload`,
  // DEFAULT_HOMEPAGE: "/home",
  // SENTRY: "https://1234567@sentry.io/12345"
};

export default settings;
